/** The size and exit rules of a Manual trading strategy: the most lots the chart may send in one entry
 * (a request for more is taken at this cap), the cost that picks the strike of an index entry, and the
 * rules that close a running trade.
 *
 * Self-gating on strategy type: each renders nothing for any other strategy. The chart
 * (docs/manual_trading.md) sends the lots with each order; the cap is the one limit the operator
 * controls from the dashboard (2026-10-30: there was no place to change it). The exit rules are
 * chosen here, not on the chart (operator, 2026-11-04), and sit under the position panel.
 */

import type { ReactElement } from "react";
import type { Strategy } from "@/types/strategy";
import { ManualExitRulesCard } from "./ManualExitRulesCard";
import { StrategySizeCard } from "./StrategySizeCard";

export function ManualTradingPanels({
  strategy,
}: Readonly<{ strategy: Strategy }>): ReactElement | null {
  if (strategy.strategy_type !== "manual") return null;
  return <StrategySizeCard strategy={strategy} />;
}

/** The exit rules, for the spot under the position panel. */
export function ManualExitRules({
  strategy,
}: Readonly<{ strategy: Strategy }>): ReactElement | null {
  if (strategy.strategy_type !== "manual") return null;
  return <ManualExitRulesCard strategy={strategy} />;
}
